import { connect } from 'react-redux'

import redirectHomeIfEmpty from '../../actions/redirectHomeIfEmpty'

const mapStateToProps = (state) => ({
  selectedPosition: state.selectedPosition,
})

const mapDispatchToProps = dispatch => ({
  onLoad: () => dispatch(redirectHomeIfEmpty())
})

export default connect(mapStateToProps, mapDispatchToProps)



// WEBPACK FOOTER //
// ./src/components/PositionsScene/positionsSceneContainer.js